module.exports = __webpack_public_path__ + "img/Azerbaijan.adbe59da.png";